
(function(template){
define('vue!app/views/vue/components/cartComponent/addGuestComponent/loginComponent',['Vue','helpers','vue!basicComponents/inputIconField','vue!basicComponents/loadingIndicator'],function(Vue,helpers,inputIconField,loadingIndicator){
    return {
        template: template,
        props: ['modeSelect'],
        components: {
            'input-icon-field' : inputIconField,
            'loading-indicator' : loadingIndicator
        },
        data: function(){
            return {
                email: '',
                password: '',
                emailMode: true,
                error:'',
                loading : false
            }
        },
        computed: {
            showGoogleLogin: function(){
                return app.customization.googleAuth.showGoogleButton;
            },
            showFbLogin: function(){
                return app.customization.facebookAuth.showFacebookButton;
            },
            showAppleLogin: function(){
                return app.customization.appleAuth.showAppleButton;
            },
            showAlternateLogin: function(){
                return app.customization.login.alternativeLogin;
            },
            isVueLogin: function(){
                return app.customization.renderVueLoginApp;
            },
            placeholders: function(){
                return {
                    "true": this.localStrings.login.ui.placeholders.emailMode,
                    "false": this.localStrings.login.ui.placeholders.folioMode
                }
            }
        },
        watch: {
            emailMode: function(){
                this.email = '';
                this.password = '';
                $('.content-spaPackageTpl #vue-cart .component-popup #focusFirst').focus();
            }
        },
        methods: {
            handleKeyDown: function(e) {
                this.a11yKeyDown(e,{
                    enter: function() {
                        e.preventDefault();
                        e.target.click();
                    }
                })
            },
            validateInput: function(e){
                if(!this.emailMode && isNaN(e.key)) e.preventDefault();
            },
            handleLoginSubmit: function(e){
                e.preventDefault();
                var vm = this;
                this.loading = true;
                helpers.loginUser(this.email, this.password, this.placeholders[this.emailMode].emailField).then(function(){
                    vm.$emit('loginSuccess')
                }).fail(function(error){
                    vm.error = error;
                }).always(function(){
                    vm.loading = false;
                })
            },
            changeMode: function(){
                this.emailMode = !this.emailMode;
            },
            hide: function(){
               if(this.error){ this.error = ''}
            },
            handleCloseClick: function(){
             
                this.$emit('toggle-Login-Form',false)
            },
            handleGoogleSignin: function(){
                var vm = this;
                vm.loading = true;
                var client = window.google.accounts.oauth2.initTokenClient({
                    client_id: app.customization.googleAuth.googleAuthClientID,
                    scope: 'https://www.googleapis.com/auth/userinfo.profile',
                    callback: function (tokenResponse) {
                        vm.loading = false;
                        var id_token = tokenResponse.id_token || tokenResponse.access_token || tokenResponse.credential;

                        helpers.loginAuthUser(id_token, 'GOOGLE').then(function(){
                            vm.$emit('loginSuccess');
                        }).fail(function(error){
                            vm.error = error;
                        }).always(function(){
                            vm.loading = false;
                        })
                    },
                    error_callback: function (error) {
                        vm.loading = false;
                        if(error.type == 'popup_closed'){
                            vm.error = app.localization.auth.applePopupClosed;
                        } else {
                            vm.error = error.message;
                        }
                    }                           
                });

                client.requestAccessToken();
            },
            handleFacebookSignin: function(){
                var vm = this;
                vm.loading = true;

                FB.login(function(response) {        
                    // handle the response
                    if (response.status === 'connected') {
                        // Logged into your webpage and Facebook.
                        helpers.loginAuthUser(response.authResponse.accessToken, 'FACEBOOK').then(function(){
                            vm.$emit('loginSuccess');
                        }).fail(function(error){
                            vm.error = error;
                        }).always(function(){
                            vm.loading = false;
                        })
                    } else {
                        vm.error = app.localization.auth.facebookPopupClosed;
                    }
                }, {scope: 'public_profile,email'});       
            },
            handleAppleSignin: function(){
                var vm = this;
                vm.loading = true;

                //Listen for authorization success
                document.addEventListener('AppleIDSignInOnSuccess', function(data){
                    helpers.loginAuthUser(data.detail.authorization.id_token, 'APPLE', data.detail.user).then(function(){
                        vm.$emit('loginSuccess');
                    }).fail(function(error){
                        vm.error = error;
                    }).always(function(){
                        vm.loading = false;
                    })
                });

                //Listen for authorization failures
                document.addEventListener('AppleIDSignInOnFailure', function(error){
                    if(error.detail.error != 'popup_closed_by_user'){
                        if(error.detail.error == 'user_trigger_new_signin_flow' || error.detail.error == 'popup_blocked_by_browser'){
                            vm.error = app.localization.auth.applePopupWindowBlocked;
                        } else vm.error = error.detail.error;
                    }
                    vm.loading = false;
                });

                appleAuth.auth.init({
                    clientId : app.customization.appleAuth.clientID,
                    scope : 'name email',
                    redirectURI : app.customization.appleAuth.redirectURL,
                    usePopup : true //or false defaults to false
                });

                appleAuth.auth.signIn();  
            }
        }
    }
})
})('<div class="segment loginContainer relative"> <loading-indicator :showLoader="loading"></loading-indicator> <div class="segment-header" v-if="!modeSelect">{{localStrings.login.ui.segmentHeader}}<span class="pointer" @click="handleCloseClick"><i class="fas fa-times-circle"></i></span></div> <form @submit="handleLoginSubmit" :class="[\'segment-body noPadding\', {\'blur-while-booking\':loading}]" aria-label="Login form"> <div v-if="error.length>0" v-click-outside="hide" role="alert" class="error-message">{{error}}</div> <!-- <input :placeholder="placeholders[emailMode][0]" @keypress="validateInput" v-model="email" type="text" /> --> <input-icon-field :placeholder="placeholders[emailMode].emailField" :text.sync="email" :type="emailMode ? \'text\' : \'number\'" :aria-label="\'E-mail Field\'"> <template v-slot:icon><i :class="[\'far\', emailMode ? \'fa-envelope\' : \'fa-address-card\']"></i></template> </input-icon-field> <!-- <input :placeholder="placeholders[emailMode][1]" v-model="password" :type="emailMode ? \'password\' : \'text\'" /> --> <input-icon-field :placeholder="placeholders[emailMode].passwordField" :text.sync="password" :type="emailMode ? \'password\' : \'text\'" :aria-label="\'Password Field\'"> <template v-slot:icon><i :class="emailMode ? \'fas fa-lock\' : \'far fa-address-card\'"></i></template> </input-icon-field> <div class="fbSpaSign" v-if="showFbLogin" ><div @click="handleFacebookSignin" id="spaFbButton" style="background: #4267b2;color: white; text-align: center;cursor:pointer;" data-max-rows="1" data-size="large" data-button-type="continue_with" data-use-continue-as="true"><i class="fab fa-facebook-f"></i>{{localStrings.login.ui.facebookSignin}}</div></div> <div class="appleSpaSign" v-if="showAppleLogin" ><div @click="handleAppleSignin" style="cursor:pointer;" data-type="sign-in" data-color="black" class="spaAppleBtn"><i class="fab fa-apple"></i>{{localStrings.login.ui.appleSignin}}</div></div> <div id="gSignInWrapper" v-if="showGoogleLogin" ><div @click="handleGoogleSignin" id="googleAuthBtn" class="spaGoogleBtn" ><i class="fab fa-google"></i>{{localStrings.login.ui.googleSignin}}</div></div> <a href="#/profile/reset" v-show="emailMode" class="pointer">{{localStrings.login.ui.forgotPassword}}</a> <a :href="isVueLogin ? \'#/profile\' : \'#/profile/create\'" class="pointer rightFloated">{{localStrings.login.ui.signUpButtonText}}</a> <div class="segment-divider" v-if="showAlternateLogin" >{{localStrings.login.ui.orText}}</div> <h4 class="alternate-login-text" tabindex="0" @keydown="handleKeyDown" v-if="showAlternateLogin" @click="changeMode">{{placeholders[emailMode].alternateLoginText}}</h4> <div class="segment-body-controls"> <button class="btn cart-login-btn" v-on:click="handleLoginSubmit">{{localStrings.login.ui.submitButtonText}}</button> </div> </form> </div>');
